// Partner openings carry local wall-clock dates/times, not browser-local dates.
// Keep them structured through the listing transform and never infer recurrence.
export function getCoverageShift(listing) {
  const source =
    listing?.schedule?.coverageShift ||
    listing?.metadata?.coverageShift ||
    (listing?.listingContractVersion === 2 ? listing.coverageVacancy : null);
  if (!source) return null;
  const { startDate, endDate, startTime, endTime, timeZone } = source;
  if (
    ![startDate, endDate].every((value) =>
      /^\d{4}-\d{2}-\d{2}$/.test(value || ''),
    ) ||
    ![startTime, endTime].every((value) =>
      /^([01]\d|2[0-3]):[0-5]\d$/.test(value || ''),
    ) ||
    typeof timeZone !== 'string' ||
    !timeZone
  )
    return null;
  return { startDate, endDate, startTime, endTime, timeZone };
}

export function coverageShiftLabels(shift) {
  if (!shift) return null;
  const { startDate, endDate, startTime, endTime, timeZone } = shift;
  const sameDay = startDate === endDate;
  return {
    dates: sameDay ? startDate : `${startDate} to ${endDate}`,
    times: `${startTime}–${endTime} ${timeZone}`,
    summary: sameDay
      ? `${startDate} · ${startTime}–${endTime} ${timeZone}`
      : `${startDate} ${startTime} → ${endDate} ${endTime} ${timeZone}`,
  };
}

export function listingScheduleSummary(listing) {
  const pattern = listing?.schedule?.pattern;
  return Array.isArray(pattern)
    ? pattern.filter(Boolean).join(', ')
    : pattern || '';
}

export function coverageOpeningSummary(listing) {
  return coverageShiftLabels(getCoverageShift(listing))?.summary || '';
}
